const map = {
	"./bar.png": 4274,
	"./battery.png": 434,
	"./blackCustom.png": 2993,
	"./box.png": 2873,
	"./code.png": 2318,
	"./cpu.png": 8775,
	"./diamond.png": 7677,
	"./folding-portable.png": 5672,
	"./high-precision.png": 7878,
	"./home.png": 1108,
	"./integrated-hardware.png": 1153,
	"./lifecycle-management.png": 2669,
	"./linked-control.png": 3336,
	"./list.png": 7721,
	"./loc.png": 8847,
	"./module.png": 217,
	"./mul.png": 9439,
	"./robot.png": 1361,
	"./scan.png": 9750,
	"./synchro.png": 9436,
	"./system.png": 3882,
	"./tag.png": 9853,
	"./traceability-query.png": 8505,
	"./whiteCustom.png": 111,
	"./wifi.png": 9158
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2121;